import { render, staticRenderFns } from "./RateLimitRuleForm.vue?vue&type=template&id=fd11f70a&scoped=true"
import script from "./RateLimitRuleForm.vue?vue&type=script&lang=js"
export * from "./RateLimitRuleForm.vue?vue&type=script&lang=js"
import style0 from "./RateLimitRuleForm.vue?vue&type=style&index=0&id=fd11f70a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd11f70a",
  null
  
)

export default component.exports